import { Components, Theme } from '@mui/material'

export const AppBarOverrides = (theme: Theme): Components['MuiAppBar'] => ({
  defaultProps: {
    elevation: 0,
    color: 'inherit',
  },
  styleOverrides: {
    root: {
      position: 'relative',
      backgroundColor: theme.palette.grey[100],
      zIndex: theme.zIndex.modal,
    },
  },
})
